import { ReactElement } from 'react';

const FVSStep10AlertContent2 = (): ReactElement => (
  <>
    <div>
      If you have incurred traffic fines in your name but someone else was driving and you are found to be eligible, you can nominate a driver within six months of receiving the outcome of your application – if you feel safe to do so.
    </div>
    <br />
    <div>
      You can provide their details below now if you wish but we will always contact you before processing a nomination as we understand your situation may change. Your decision to nominate them or not will not affect the outcome of your application.
    </div>
  </>
);

export default FVSStep10AlertContent2;
